import {Alert} from 'platform/components';

import i18n from '@dms/i18n';

import {suffixTestId, type RequiredTestIdProps} from 'shared/web';

interface GenerationErrorBannerProps extends RequiredTestIdProps {
  count: number;
}

export function GenerationErrorBanner(props: GenerationErrorBannerProps) {
  return (
    <Alert
      type="inline"
      variant="error"
      message={i18n.t('entity.order.documents.couldNotBeGenerated', {
        count: props.count,
      })}
      data-testid={suffixTestId('generationErrorBanner', props)}
    />
  );
}
